import { Enum } from "./Enum";

export const E_UserFlag = Object.freeze({
  MAIN: "/user-flag",
  BY_ID: (id = ":id") => `/user-flag/${id}`,
  TYPE_BY_ID: (id = ":id") => `/user-flag/type/${id}`,
  ME: "/user-flag/me",
});

export type EUserFlag = Enum<typeof E_UserFlag>;
